import {
  Button,
  Checkbox,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Grid,
  IconButton,
  InputAdornment,
  makeStyles,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme
} from '@material-ui/core';
import AddBoxIcon from '@material-ui/icons/AddBox';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import ArrowForwardIcon from '@material-ui/icons/ArrowForward';
import CancelIcon from '@material-ui/icons/Cancel';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CloseIcon from '@material-ui/icons/Close';
import DeleteIcon from '@material-ui/icons/Delete';
import HourglassEmptyIcon from '@material-ui/icons/HourglassEmpty';
import InfoIcon from '@material-ui/icons/Info';
import SearchIcon from '@material-ui/icons/Search';
import { Autocomplete } from '@material-ui/lab';

import SendIcon from '@mui/icons-material/Send';
import Tooltip from '@mui/material/Tooltip';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import CustomAlert from '../../../components/alert/CustomAlert';
import BlueButton from '../../../components/button/BlueButton';
import authService from '../../../Services/auth/auth-service';
import remanufaturaService from '../../../Services/remanufatura/remanufatura-service';
import usuarioService from '../../../Services/Usuario/usuario-service';
import FilesExportFilterProducts from '../../../servicos/components/filesExportFilterProducts';

const useStyles = makeStyles((theme) => ({
  addButton: {
    [theme.breakpoints.up('md')]: { width: 'auto', marginBottom: theme.spacing(2), marginLeft: 0 },
    [theme.breakpoints.down('md')]: { width: '100%', marginBottom: theme.spacing(2) },
  },
  enviarButton: {
    [theme.breakpoints.up('md')]: { marginTop: theme.spacing(2), width: 'auto', maxWidth: '200px' },
    [theme.breakpoints.down('md')]: { width: '100%', marginTop: theme.spacing(2) },
    display: 'flex',
    justifyContent: 'center',
  },
  itemContainer: {
    padding: 16,
    height: '100%',
    boxSizing: 'border-box',
    justifyContent: 'space-between',
    flexDirection: 'column',
    borderBottom: `1px solid ${theme.palette.divider}`,
  },
  actionButtons: { display: 'flex', justifyContent: 'center', gap: theme.spacing(2), margin: theme.spacing(1) },
  truncatedText: { wordWrap: 'break-word', whiteSpace: 'normal', overflow: 'hidden', textOverflow: 'ellipsis', textAlign: 'center' },
  dialogContent: { [theme.breakpoints.up('sm')]: { width: '600px' } },
  dialogPaperMobile: { width: '90vw', maxWidth: '90vw' },
  centeredText: { textAlign: 'center' },
  searchFieldContainer: { width: '100%', height: 'auto' },
  searchField: {
    '& .MuiOutlinedInput-root': { height: '43px', padding: 0, display: 'flex', alignItems: 'center' },
    '& .MuiInputBase-input': { padding: '8px 0', textAlign: 'center' },
    '& .MuiInputLabel-root': { top: '-6px' },
  },
}));

export function ProdutosTable({
  estoqueItens,
  itensOS,
  addProduto,
  alteraProduto,
  consultaDetalheOS,
  consultaProdutosEstoque,
  os,
  na,
  alteraStatusOS,
  removeItemOS,
  noShowMode, // ✅ vem da OrdemServicoPage
}) {
  const classes = useStyles();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  const [produtosTemporarios, setProdutosTemporarios] = useState([]);
  const [produtosRemanufatura, setProdutosRemanufatura] = useState([]);
  const [produtoEstoqueSelecionado, setProdutoEstoqueSelecionado] = useState(null);
  const [produtoRemanufaturaSelecionado, setProdutoRemanufaturaSelecionado] = useState(null);
  const [motivoProdutoRemanufatura, setMotivoProdutoRemanufatura] = useState('');
  const [quantidadeProduto, setQuantidadeProduto] = useState(1);
  const [usuarioEstoqueAtivo, setUsuarioEstoqueAtivo] = useState(false);

  const [abrirDialog, setAbrirDialog] = useState(false);
  const [abrirDialogConfirmacao, setAbrirDialogConfirmacao] = useState(false);

  const [editandoIndex, setEditandoIndex] = useState(null);
  const [termoPesquisa, setTermoPesquisa] = useState('');

  const [mensagemAlert, setMensagemAlert] = useState({ title: '', body: '' });
  const [abrirAlert, setAbrirAlert] = useState(false);
  const [tipoAlert, setTipoAlert] = useState('success');

  const [dataExportacao, setDataExportacao] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);

  const [carregandoEnvioProdutos, setCarregandoEnvioProdutos] = useState(false);
  const textRef = useRef();

  const [itemEstoque, setItemEstoque] = useState(true);
  const [erroProdutoRemanufatura, setErroProdutoRemanufatura] = useState(false);
  const [erroMotivo, setErroMotivo] = useState(false);
  const [baseDeTroca, setBaseDeTroca] = useState(false);

  // mensagem inline (vermelha) sob o Autocomplete
  const [erroDuplicidade, setErroDuplicidade] = useState(null);

  const itemsPerPage = isMobile ? 3 : 6;

  // ✅ IDs/Códigos permitidos no NO SHOW
  const NOSHOW_ALLOWED_CODES = ['S000.0450.00', 'S000.2018.00', 'S000.1226.00']; // NO SHOW e TARIFA DE DESLOCAMENTO
  const NOSHOW_ALLOWED_NAMES = ['NO SHOW', 'TARIFA DE DESLOCAMENTO', 'SERVICO DE PEDAGIO'];

  const normaliza = (v) => (v ?? '').toString().trim().toUpperCase();

  const getCodigo = (obj) =>
    obj?.codigoProduto ?? obj?.numeroProduto ?? obj?.produtoNumero ?? obj?.produtoCodigo ?? null;

  const isNoShowAllowed = (item) => {
    if (!item) return false;
    const codigo = normaliza(getCodigo(item));
    const nome = normaliza(item?.nome ?? item?.produto ?? item?.descricao ?? '');
    if (NOSHOW_ALLOWED_CODES.includes(codigo)) return true;
    return NOSHOW_ALLOWED_NAMES.some((n) => nome === normaliza(n) || nome.includes(normaliza(n)));
  };

  const abrirAlertInfo = (title, body) => {
    setMensagemAlert({ title, body });
    setTipoAlert('success');
    setAbrirAlert(true);
  };

  const abrirAlertErro = (title, body) => {
    setMensagemAlert({ title, body });
    setTipoAlert('error');
    setAbrirAlert(true);
  };

  const abrirAlertAtencao = (title, body) => {
    setMensagemAlert({ title, body });
    setTipoAlert('fail');
    setAbrirAlert(true);
  };

  const motivosDesconto = [
    { id: 'UPGRADE', label: 'UPGRADE' },
    { id: 'COMODATO', label: 'COMODATO' },
    { id: 'GARANTIA', label: 'GARANTIA' },
    { id: 'MANUTENCAO', label: 'MANUTENÇÃO' }
  ];

  useEffect(() => {
    buscarUsuarioEstoqueAtivo();
    buscarProdutosRemanufatura();
  }, [os]);

  const abrirModalAdicionarItens = async () => {
    setProdutoRemanufaturaSelecionado(null);
    setBaseDeTroca(false);
    setErroDuplicidade(null);
    setProdutoEstoqueSelecionado(null);
    setQuantidadeProduto(1);
    setAbrirDialog(true);

  };

  const buscarProdutosRemanufatura = async () => {
    const response = await remanufaturaService.listarProdutosRemanufaturadosTecnicos();
    if (!response.error) setProdutosRemanufatura(response);
  };

  const buscarUsuarioEstoqueAtivo = async () => {
    try {
      const response = await usuarioService.usuarioEstoqueAtivo(authService.getUserInfo().usuario.id);
      if (!response.error) setUsuarioEstoqueAtivo(response);
    } catch (error) {
      abrirAlertErro('Erro!', 'Erro ao verificar o estoque do usuário.');
    }
  };

  const safeLabel = (option) => {
    if (!option) return '';
    const codigo = getCodigo(option) || '';
    const nome = option?.nome ?? option?.produto ?? option?.descricao ?? '';
    if (codigo && nome) return `${codigo} - ${nome}`;
    return codigo || nome || '-';
  };

  const isSameOption = (a, b) => {
    if (!a || !b) return false;
    if (a.produtoId && b.produtoId) return a.produtoId === b.produtoId;
    const ca = getCodigo(a);
    const cb = getCodigo(b);
    return !!ca && !!cb && ca === cb;
  };

  // Verifica duplicidade por código (itensOS + temporários)
  const jaExisteItemComCodigo = (
    codigo,
    { ignoreOSItemID = null, ignoreTempId = null } = {}
  ) => {
    if (!codigo) return false;

    const existeNaOS = itensOS?.some((i) => {
      const cod = getCodigo(i);
      if (cod !== codigo) return false;
      if (ignoreOSItemID && i?.itemID === ignoreOSItemID) return false;
      return true;
    });

    const existeNoTemp = produtosTemporarios?.some((i) => {
      const cod = getCodigo(i);
      if (cod !== codigo) return false;
      if (ignoreTempId && i?.id === ignoreTempId) return false;
      return true;
    });

    return Boolean(existeNaOS || existeNoTemp);
  };

  // Trava específica de serviço por produtoId
  const jaExisteServicoComProduto = (
    produtoId,
    { ignoreOSItemID = null, ignoreTempId = null } = {}
  ) => {
    const existeNaOS = itensOS?.some((i) => {
      if (i?.ehServico !== true) return false;
      if (i?.produtoId !== produtoId) return false;
      if (ignoreOSItemID && i?.itemID === ignoreOSItemID) return false;
      return true;
    });

    const existeNoTemp = produtosTemporarios?.some((i) => {
      if (i?.ehServico !== true) return false;
      if (i?.produtoId !== produtoId) return false;
      if (ignoreTempId && i?.id === ignoreTempId) return false;
      return true;
    });

    return Boolean(existeNaOS || existeNoTemp);
  };

  const getDuplicidadeMsg = (opt) => {
    if (!opt) return null;
    const ignoreOSItemID = opt?.itemID ?? null;
    const ignoreTempId = editandoIndex !== null ? produtosTemporarios?.[editandoIndex]?.id : null;

    const codigoSel = getCodigo(opt);
    if (codigoSel && jaExisteItemComCodigo(codigoSel, { ignoreOSItemID, ignoreTempId })) {
      return 'Já existe um item com este código no orçamento. Aumente a quantidade do item existente.';
    }
    if (opt?.ehServico === true && jaExisteServicoComProduto(opt.produtoId, { ignoreOSItemID, ignoreTempId })) {
      return 'Este serviço já foi adicionado. Atualize a quantidade do item existente.';
    }
    return null;
  };

  const adicionarProdutoTemporario = () => {
    try {
      if (!produtoEstoqueSelecionado || quantidadeProduto < 1) {
        abrirAlertAtencao('Atenção!', 'Por favor, selecione um produto e defina uma quantidade válida.');
        return;
      }

      if (noShowMode && !isNoShowAllowed(produtoEstoqueSelecionado)) {
        abrirAlertAtencao(
          'Item não permitido no NO SHOW',
          'Quando NO SHOW estiver ativo, só pode adicionar NO SHOW e TARIFA DE DESLOCAMENTO.'
        );
        return;
      }

      const codigoSel = getCodigo(produtoEstoqueSelecionado);
      const produtoIdSel = produtoEstoqueSelecionado.produtoId;
      const novaQuantidade = Number(quantidadeProduto || 0);

      const itemJaSalvoNaOS = itensOS?.find((item) => {
        const mesmoCodigo = codigoSel && getCodigo(item) === codigoSel;
        const mesmoProduto = produtoIdSel && item?.produtoId === produtoIdSel;
        return mesmoCodigo || mesmoProduto;
      });

      if (itemJaSalvoNaOS) {
        abrirAlertAtencao(
          'Item já existe na OS',
          'Este produto/serviço já foi adicionado na OS. Não é permitido inserir duplicado. Altere a quantidade do item existente.'
        );
        return;
      }

      const indexTempDuplicado = produtosTemporarios.findIndex((item) => {
        const mesmoCodigo = codigoSel && getCodigo(item) === codigoSel;
        const mesmoProduto = produtoIdSel && item?.produtoId === produtoIdSel;
        return mesmoCodigo || mesmoProduto;
      });

      if (indexTempDuplicado !== -1 && editandoIndex === null) {
        const produtosAtualizados = [...produtosTemporarios];
        const itemAtual = produtosAtualizados[indexTempDuplicado];

        const quantidadeAtual = Number(itemAtual.quantidade || 0);
        const quantidadeTotal = quantidadeAtual + novaQuantidade;

        if (produtoEstoqueSelecionado.ehServico === false && usuarioEstoqueAtivo === true) {
          if (quantidadeTotal > produtoEstoqueSelecionado.qtdDisponivel) {
            abrirAlertAtencao(
              'Atenção!',
              'A quantidade total excede a quantidade disponível em estoque.'
            );
            return;
          }
        }

        if (
          produtoEstoqueSelecionado.ehServico === false &&
          usuarioEstoqueAtivo === false &&
          produtoEstoqueSelecionado.quantidadeDisponivelRegras === true
        ) {
          if (quantidadeTotal > produtoEstoqueSelecionado.limiteQuantidade) {
            abrirAlertAtencao(
              'Atenção!',
              'A quantidade total excede a quantidade máxima permitida.'
            );
            return;
          }
        }

        produtosAtualizados[indexTempDuplicado] = {
          ...itemAtual,
          quantidade: quantidadeTotal,
        };

        setProdutosTemporarios(produtosAtualizados);
        abrirAlertInfo(
          'Quantidade atualizada!',
          `O item já existia temporariamente. A quantidade foi atualizada para ${quantidadeTotal}.`
        );

        setAbrirDialog(false);
        resetarCampos();
        return;
      }

      const produtoTemporario = {
        id: editandoIndex !== null ? produtosTemporarios[editandoIndex].id : new Date().getTime(),
        produtoId: produtoEstoqueSelecionado.produtoId,
        produto: produtoEstoqueSelecionado.nome,
        quantidade: novaQuantidade,
        codigoProduto: produtoEstoqueSelecionado.produtoNumero ?? codigoSel,
        numeroProduto: produtoEstoqueSelecionado.produtoNumero ?? codigoSel,
        descStatus: 'Temporário',
        ehServico: produtoEstoqueSelecionado.ehServico,
        itemDeEstoque: produtoEstoqueSelecionado.ehServico === true ? false : itemEstoque,
        baseDeTroca: produtoEstoqueSelecionado.ehServico === true ? false : baseDeTroca,
        codItemBaseDeTroca: produtoEstoqueSelecionado.ehServico === true ? null : produtoRemanufaturaSelecionado?.produtoCodigo,
        nomeItemBaseDeTroca: produtoEstoqueSelecionado.ehServico === true ? null : produtoRemanufaturaSelecionado?.produtoNome,
        motivoProdutoRemanufatura: produtoEstoqueSelecionado.ehServico === true ? null : motivoProdutoRemanufatura,
        limiteQuantidade: produtoEstoqueSelecionado.ehServico === true ? null : produtoEstoqueSelecionado.limiteQuantidade,
        quantidadeDisponivelRegras: produtoEstoqueSelecionado.ehServico === true ? null : produtoEstoqueSelecionado.quantidadeDisponivelRegras
      };

      if (editandoIndex !== null) {
        const updatedProdutos = [...produtosTemporarios];
        updatedProdutos[editandoIndex] = produtoTemporario;
        setProdutosTemporarios(updatedProdutos);
        setEditandoIndex(null);
      } else {
        setProdutosTemporarios([...produtosTemporarios, produtoTemporario]);
      }

      setAbrirDialog(false);
      resetarCampos();
    } catch (error) {
      abrirAlertErro('Atenção!', 'Falha ao adicionar o produto.');
    }
  };

  const preparaDadosParaExportacao = async () => {
    let data = [];
    if (itensOS.length > 0) {
      for (let itens of itensOS) {
        let itensObjeto = {
          'Número do Produto': itens.numeroProduto ?? itens.codigoProduto ?? '',
          'Produto': itens.produto,
          'Quantidade': itens.quantidade,
          'Status': itens.descStatus
        };
        data.push(itensObjeto);
      }
    }
    setDataExportacao(data);
  };

  const handleSalvarAlteracoes = () => {
    let hasError = false;

    if (!produtoEstoqueSelecionado) {
      abrirAlertAtencao('Atenção!', 'Selecione um produto.');
      hasError = true;
    }

    if (quantidadeProduto <= 0) {
      abrirAlertAtencao('Atenção!', 'Quantidade deve ser maior que 0.');
      hasError = true;
    }

    if (
      baseDeTroca &&
      (!produtoRemanufaturaSelecionado || !motivoProdutoRemanufatura.trim())
    ) {
      abrirAlertAtencao('Atenção!', 'Base de troca requer a seleção de um produto e o motivo.');
      hasError = true;
    }

    // ✅ NO SHOW: bloqueia salvar itens fora do permitido
    if (noShowMode && produtoEstoqueSelecionado && !isNoShowAllowed(produtoEstoqueSelecionado)) {
      abrirAlertAtencao(
        'Item não permitido no NO SHOW',
        'Quando NO SHOW estiver ativo, só pode adicionar NO SHOW e TARIFA DE DESLOCAMENTO.'
      );
      hasError = true;
    }

    const msg = getDuplicidadeMsg(produtoEstoqueSelecionado);
    setErroDuplicidade(msg);
    if (msg) hasError = true;

    if (hasError) return;

    if (editandoIndex !== null) {
      aplicarEdicao();
    } else {
      adicionarProdutoTemporario();
    }
  };

  const aplicarEdicao = async () => {
    try {
      if (!produtoEstoqueSelecionado || quantidadeProduto < 1) {
        abrirAlertAtencao('Atenção!', 'Por favor, selecione um produto e defina uma quantidade válida.');
        return;
      }

      // ✅ NO SHOW: bloqueia editar para item fora do permitido
      if (noShowMode && !isNoShowAllowed(produtoEstoqueSelecionado)) {
        abrirAlertAtencao(
          'Item não permitido no NO SHOW',
          'Quando NO SHOW estiver ativo, só pode usar NO SHOW e TARIFA DE DESLOCAMENTO.'
        );
        return;
      }

      const codigoSel = getCodigo(produtoEstoqueSelecionado);

      const msg = getDuplicidadeMsg(produtoEstoqueSelecionado);
      setErroDuplicidade(msg);
      if (msg) return;

      const index = produtosTemporarios.findIndex((item) => item.id === editandoIndex);
      const produtoExistente = itensOS.find((item) => item.produtoId === produtoEstoqueSelecionado.produtoId && item.id === produtoEstoqueSelecionado.id);
      const produtoServico = estoqueItens.find((item) => item.produtoId === produtoEstoqueSelecionado.produtoId);

      if (produtoExistente) {
        let quantidadeTotalInserida = parseFloat(quantidadeProduto);

        const produtosInseridos = itensOS.filter((item) => item.produtoId === produtoEstoqueSelecionado.produtoId);

        if (produtoEstoqueSelecionado.ehServico === false && usuarioEstoqueAtivo === true) {
          if (produtosInseridos) {
            produtosInseridos.forEach(produto => {
              quantidadeTotalInserida += parseFloat(produto.quantidade);
            });
          }
          quantidadeTotalInserida = Math.abs(quantidadeTotalInserida - (produtoExistente?.quantidade || 0));

          if (quantidadeTotalInserida > produtoEstoqueSelecionado.qtdDisponivel) {
            abrirAlertAtencao('Atenção!', 'A soma total dos itens adicionados excede a quantidade do produto disponível em estoque.');
            return;
          }
        } else if (produtoEstoqueSelecionado.ehServico === false && usuarioEstoqueAtivo === false) {
          if (produtosInseridos) {
            produtosInseridos.forEach(produto => {
              quantidadeTotalInserida += parseFloat(produto.quantidade);
            });
          }
          quantidadeTotalInserida = Math.abs(quantidadeTotalInserida - (produtoExistente?.quantidade || 0));

          if (produtoServico?.quantidadeDisponivelRegras == true) {
            if (quantidadeTotalInserida > produtoServico.limiteQuantidade) {
              abrirAlertAtencao('Atenção!', 'A soma total dos itens adicionados excede a quantidade máxima que pode ser inserida.');
              return;
            }
          }
        }

        setCarregandoEnvioProdutos(true);

        let retorno = await alteraProduto(
          produtoEstoqueSelecionado.produtoId,
          produtoEstoqueSelecionado.produto ?? produtoEstoqueSelecionado.nome ?? '',
          quantidadeProduto,
          codigoSel,
          produtoEstoqueSelecionado.itemID,
          produtoServico?.ehServico,
          produtoEstoqueSelecionado.itemDeEstoque,
          produtoEstoqueSelecionado.baseDeTroca,
          produtoEstoqueSelecionado.codItemBaseDeTroca,
          produtoEstoqueSelecionado.nomeItemBaseDeTroca,
          produtoEstoqueSelecionado.serialItemBaseDeTroca,
          produtoEstoqueSelecionado.motivoProdutoRemanufatura,
        );

        if (retorno === true) {
          setAbrirDialog(false);
          abrirAlertInfo('Sucesso!', 'Produto alterado com sucesso.');
          resetarCampos();
          consultaDetalheOS();
          consultaProdutosEstoque();
          setCarregandoEnvioProdutos(false);
        }
        setCarregandoEnvioProdutos(false);
        return;
      }

      if (index !== -1) {
        let quantidadeTotal = parseFloat(quantidadeProduto);

        const produtosExistentes = produtosTemporarios.filter((produto) =>
          produto.produtoId === produtoEstoqueSelecionado.produtoId && produto.id !== produtoEstoqueSelecionado.id
        );

        const produtosInseridos = itensOS.filter((item) => item.produtoId === produtoEstoqueSelecionado.produtoId);

        if (produtoEstoqueSelecionado.ehServico === false && usuarioEstoqueAtivo === true) {
          if (produtosInseridos) {
            produtosInseridos.forEach(produto => {
              quantidadeTotal += parseFloat(produto.quantidade);
            });
          } else if (produtosExistentes.length > 0) {
            produtosExistentes.forEach(produto => {
              quantidadeTotal += parseFloat(produto.quantidade);
            });
          }

          if (quantidadeTotal > produtoEstoqueSelecionado.qtdDisponivel) {
            abrirAlertAtencao('Atenção!', 'A soma total dos itens adicionados excede a quantidade do produto disponível em estoque.');
            return;
          }
        } else if (produtoEstoqueSelecionado.ehServico === false && usuarioEstoqueAtivo === false) {
          if (produtosInseridos) {
            produtosInseridos.forEach(produto => {
              quantidadeTotal += parseFloat(produto.quantidade);
            });
          } else if (produtosExistentes.length > 0) {
            produtosExistentes.forEach(produto => {
              quantidadeTotal += parseFloat(produto.quantidade);
            });
          }

          if (produtoServico?.quantidadeDisponivelRegras == true) {
            if (quantidadeTotal > produtoServico.limiteQuantidade) {
              abrirAlertAtencao('Atenção!', 'A soma total dos itens adicionados excede a quantidade máxima que pode ser inserida.');
              return;
            }
          }
        }

        const updatedProdutos = [...produtosTemporarios];
        updatedProdutos[index] = {
          ...updatedProdutos[index],
          id: produtoEstoqueSelecionado.id,
          produtoId: produtoEstoqueSelecionado.produtoId,
          produto: produtoEstoqueSelecionado.nome ?? produtoEstoqueSelecionado.produto ?? '',
          produtoNumero: getCodigo(produtoEstoqueSelecionado),
          quantidade: quantidadeProduto,
          itemDeEstoque: produtoEstoqueSelecionado.itemDeEstoque,
          baseDeTroca: produtoEstoqueSelecionado.baseDeTroca,
          codItemBaseDeTroca: produtoEstoqueSelecionado.codItemBaseDeTroca,
          nomeItemBaseDeTroca: produtoEstoqueSelecionado.nomeItemBaseDeTroca,
          serialItemBaseDeTroca: produtoEstoqueSelecionado.serialItemBaseDeTroca,
          motivoProdutoRemanufatura: produtoEstoqueSelecionado.motivoProdutoRemanufatura,
          limiteQuantidade: produtoEstoqueSelecionado.limiteQuantidade,
          quantidadeDisponivelRegras: produtoEstoqueSelecionado.quantidadeDisponivelRegras
        };

        setProdutosTemporarios(updatedProdutos);
        setAbrirDialog(false);
        abrirAlertInfo('Sucesso!', 'Produto alterado com sucesso.');
        resetarCampos();
      } else {
        abrirAlertErro('Erro!', 'Produto não encontrado.');
      }
    } catch (error) {
      abrirAlertErro('Erro!', 'Erro ao aplicar as alterações no produto.');
    }
  };

  const removerProduto = async (id, itemID, dadosProduto) => {
    try {
      if (itemID) {
        const ehServico = estoqueItens.find((item) => item.produtoNumero === dadosProduto.numeroProduto)?.ehServico;
        const removerItem = await removeItemOS(itemID, dadosProduto, ehServico);
        if (removerItem === true) {
          abrirAlertInfo('Sucesso!', 'Item removido com sucesso.');
          consultaDetalheOS();
          return;
        } else {
          abrirAlertErro('Erro!', removerItem.message);
          return;
        }
      }

      const produto = produtosTemporarios.find((item) => item.id === id);

      if (!produto) {
        abrirAlertAtencao('Atenção!', 'Produto não encontrado.');
        return;
      }

      const updatedProdutos = produtosTemporarios.filter((item) => item.id !== id);
      setProdutosTemporarios(updatedProdutos);

      setProdutoEstoqueSelecionado(null);
      setQuantidadeProduto(1);
      setEditandoIndex(null);

      abrirAlertInfo('Sucesso!', `Produto ${produto.produto} removido com sucesso.`);
    } catch (error) {
      abrirAlertErro('Erro!', 'Erro ao remover o produto.');
    }
  };

  const resetarCampos = () => {
    setProdutoEstoqueSelecionado(null);
    setProdutoRemanufaturaSelecionado('');
    setMotivoProdutoRemanufatura('');
    setQuantidadeProduto(1);
    setEditandoIndex(null);
    setItemEstoque(true);
    setErroDuplicidade(null);
    setErroProdutoRemanufatura(false);
    setErroMotivo(false);
    setBaseDeTroca(false);
  };

  const enviarProdutos = async (event) => {
    event.preventDefault();

    if (carregandoEnvioProdutos) return;

    setCarregandoEnvioProdutos(true);

    try {
      if (!produtosTemporarios.length) {
        setMensagemAlert({ title: 'Atenção!', body: 'Nenhum produto temporário para enviar.' });
        setTipoAlert('fail');
        setAbrirAlert(true);
        setCarregandoEnvioProdutos(false);
        return;
      }

      if (os?.status === 'Concluido') {
        await alteraStatusOS();
      }

      const enviadosComSucesso = [];
      const produtosComErro = [];

      for (const produto of produtosTemporarios) {
        const retorno = await addProduto(
          produto.produtoId,
          produto.produto,
          produto.quantidade,
          produto.codigoProduto,
          produto.ehServico,
          produto.itemDeEstoque,
          produto.baseDeTroca,
          produto.codItemBaseDeTroca,
          produto.nomeItemBaseDeTroca,
          produto.motivoProdutoRemanufatura
        );

        if (retorno === true) {
          enviadosComSucesso.push(produto.id);
        } else {
          produtosComErro.push(produto);
        }
      }

      if (enviadosComSucesso.length > 0) {
        setProdutosTemporarios((prev) =>
          prev.filter((produto) => !enviadosComSucesso.includes(produto.id))
        );

        await consultaDetalheOS();
        await consultaProdutosEstoque();
      }

      if (produtosComErro.length === 0) {
        setMensagemAlert({
          title: 'Sucesso!',
          body: 'Produtos enviados com sucesso!'
        });
        setTipoAlert('success');
      } else {
        setMensagemAlert({
          title: 'Atenção!',
          body: `${enviadosComSucesso.length} produto(s) enviado(s). ${produtosComErro.length} produto(s) não foram enviados.`
        });
        setTipoAlert('fail');
      }

      setAbrirAlert(true);
    } catch (error) {
      setMensagemAlert({
        title: 'Erro!',
        body: 'Erro ao enviar os produtos.'
      });
      setTipoAlert('error');
      setAbrirAlert(true);
    } finally {
      setCarregandoEnvioProdutos(false);
    }
  };

  useEffect(() => {
    preparaDadosParaExportacao();
  }, [os]);

  const filtrarProdutos = useMemo(() => {
    return itensOS.concat(produtosTemporarios).filter(
      (item) =>
        (
          item &&
          item.produto &&
          item.produto.toLowerCase().includes((termoPesquisa || '').toLowerCase())
        ) ||
        (
          item?.codigoProduto &&
          item.codigoProduto.toLowerCase().includes((termoPesquisa || '').toLowerCase())
        ) ||
        (
          item?.numeroProduto &&
          item.numeroProduto.toLowerCase().includes((termoPesquisa || '').toLowerCase())
        )
    );
  }, [termoPesquisa, itensOS, produtosTemporarios]);

  const produtosFiltrados = filtrarProdutos;
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = produtosFiltrados.slice(indexOfFirstItem, indexOfLastItem);

  const handleNextPage = useCallback(() => {
    if (currentPage < Math.ceil(produtosFiltrados.length / itemsPerPage)) {
      setCurrentPage((prevPage) => prevPage + 1);
    }
  }, [currentPage, produtosFiltrados.length, itemsPerPage]);

  const handlePreviousPage = useCallback(() => {
    if (currentPage > 1) {
      setCurrentPage((prevPage) => prevPage - 1);
    }
  }, [currentPage]);

  const totalPages = Math.ceil(produtosFiltrados.length / itemsPerPage);

  useEffect(() => {
    setCurrentPage(1);
  }, [produtosFiltrados]);

  const StatusDiv = ({ status }) => {
    let textoStatus = '';
    let statusCor = '';
    let IconeStatus = null;

    switch (status) {
      case 'Aprovado':
        textoStatus = 'Aprovado';
        statusCor = 'rgba(3, 201, 169, 1)';
        IconeStatus = CheckCircleIcon;
        break;
      case 'Aguardando Aprovacao':
        textoStatus = 'Aguardando Aprovação';
        statusCor = '#777';
        IconeStatus = HourglassEmptyIcon;
        break;
      case 'Recusado':
        textoStatus = 'Recusado';
        statusCor = 'rgba(255, 99, 132, 1)';
        IconeStatus = CancelIcon;
        break;
      case 'Temporário':
        textoStatus = 'Temporário';
        statusCor = '#87CEEB';
        IconeStatus = InfoIcon;
        break;
      default:
        textoStatus = 'Desconhecido';
        statusCor = '#000';
        IconeStatus = InfoIcon;
        break;
    }

    return (
      <div style={{
        fontSize: '0.8rem',
        fontWeight: '500',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        padding: '5px 5px',
        color: '#fff',
        borderRadius: '10px',
        textAlign: 'center',
        backgroundColor: statusCor,
        maxWidth: '200px',
        margin: '0 auto',
      }}>
        <IconeStatus style={{ marginRight: '8px', color: '#fff' }} />
        {textoStatus}
      </div>
    );
  };

  const itensAdicionados = currentItems.length > 0;

  useEffect(() => {
    if (produtoEstoqueSelecionado?.nome?.includes('TERMINAL')) {
      const terminal = produtosRemanufatura?.find((option) => option.produtoNome === 'TERMINAL');
      setProdutoRemanufaturaSelecionado(terminal);
    }
    else if (produtoEstoqueSelecionado?.nome?.includes('MODULO')) {
      const modulo = produtosRemanufatura?.find((option) => option.produtoNome === 'MODULO');
      setProdutoRemanufaturaSelecionado(modulo);
    }
    else if (produtoEstoqueSelecionado?.nome?.includes('ANTENA')) {
      const antena = produtosRemanufatura?.find((option) => option.produtoNome === 'ANTENA');
      setProdutoRemanufaturaSelecionado(antena);
    }
  }, [produtoEstoqueSelecionado, produtosRemanufatura]);

  const fecharModalConfirmacao = () => {
    setAbrirDialogConfirmacao(false);
  };

  // ✅ opções do autocomplete de acordo com NO SHOW / tipo de serviço
  const opcoesAutocomplete = useMemo(() => {
    if (noShowMode) {
      return (estoqueItens || []).filter(isNoShowAllowed);
    }
    if (os?.tipoServicoAgendamento === 'INSTALACAO') {
      return (estoqueItens || []).filter((item) => item?.nome !== 'TARIFA DE DESLOCAMENTO');
    }
    return (estoqueItens || []);
  }, [noShowMode, estoqueItens, os]);

  return (
    <>
      <CustomAlert
        open={abrirAlert}
        message={mensagemAlert}
        type={tipoAlert}
        onClose={() => setAbrirAlert(false)}
      />

      <Grid container spacing={2}>
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Grid item xs={12} sm={3} md={3}>
            <FilesExportFilterProducts
              fileName={`Orçamento da ${na}`}
              data={dataExportacao}
            />
          </Grid>
        </Grid>

        <Grid item xs={12}>
          <Paper style={{ padding: 10 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={3} md={3}>
                <BlueButton
                  fullWidth
                  variant="contained"
                  color="primary"
                  size="large"
                  startIcon={<AddBoxIcon />}
                  onClick={abrirModalAdicionarItens}
                  style={{ marginBottom: 10 }}
                >
                  Adicionar Produto
                </BlueButton>
              </Grid>

              <Grid item xs={12} md={5}></Grid>

              <Grid item xs={12} sm={6} md={4}>
                <div className={classes.searchFieldContainer}>
                  <TextField
                    fullWidth
                    variant="outlined"
                    label="Pesquisar Produto"
                    value={termoPesquisa}
                    onChange={(e) => setTermoPesquisa(e.target.value)}
                    className={classes.searchField}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end" style={{ marginRight: 10 }}>
                          <SearchIcon />
                        </InputAdornment>
                      ),
                    }}
                  />
                </div>
              </Grid>
            </Grid>

            {!itensAdicionados && (
              <Typography
                variant="body1"
                align="center"
                color="textSecondary"
                style={{ paddingTop: theme.spacing(8), paddingBottom: theme.spacing(8) }}
              >
                Nenhum produto ou serviço adicionado.
              </Typography>
            )}

            {itensAdicionados && (
              <Grid container spacing={1} style={{ marginTop: theme.spacing(3) }} ref={textRef}>
                {currentItems.map((item, index) => (
                  <Grid item xs={12} sm={isMobile ? 12 : 4} md={4} key={`${item.produtoId}-${index}`}>
                    <Paper className={classes.itemContainer}>
                      <Grid container spacing={1}>
                        <Grid item xs={12} style={{ textAlign: 'center' }}>
                          <Tooltip title={item.produto} placement="top" arrow>
                            <Typography component="div" variant="body2" className={classes.truncatedText}>
                              {item.produto}
                            </Typography>
                          </Tooltip>
                        </Grid>
                        <Grid item xs={12} className={classes.centeredText}>
                          <Typography component="div" variant="body2">Código: {item.numeroProduto ? item.numeroProduto : item.codigoProduto} </Typography>
                        </Grid>
                        <Grid item xs={12} className={classes.centeredText}>
                          <Typography component="div" variant="body2">Quantidade: {item.quantidade}</Typography>
                        </Grid>
                        <Grid item xs={12} className={classes.centeredText}>
                          <StatusDiv status={item.descStatus} />
                        </Grid>
                        <Grid item xs={12} className={classes.actionButtons}>
                          <BlueButton
                            variant="contained"
                            color="secondary"
                            startIcon={<DeleteIcon />}
                            onClick={() => removerProduto(item.id, item.itemID, item)}
                          >
                            Remover
                          </BlueButton>
                        </Grid>
                      </Grid>
                    </Paper>
                  </Grid>
                ))}
              </Grid>
            )}
          </Paper>
        </Grid>
      </Grid>

      {produtosTemporarios.length > 0 && (
        <Grid item xs={12} style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Grid item xs={12} sm={3} md={3}>
            <BlueButton
              fullWidth
              variant="contained"
              color="primary"
              onClick={enviarProdutos}
              disabled={carregandoEnvioProdutos}
              style={{ marginTop: theme.spacing(2), height: 55 }}
              startIcon={carregandoEnvioProdutos ? <CircularProgress size={20} /> : <SendIcon />}
            >
              <span style={{ fontSize: '0.7rem' }}>{carregandoEnvioProdutos ? ' Enviando...' : ' Enviar Orçamento'}</span>
            </BlueButton>
          </Grid>
        </Grid>
      )}

      {totalPages > 1 && (
        <Grid container justify="center" style={{ marginTop: theme.spacing(3) }}>
          <Button onClick={handlePreviousPage} disabled={currentPage === 1}>
            <ArrowBackIcon />
          </Button>
          <Typography variant="body2" style={{ padding: '10px 16px' }}>
            Página {currentPage} de {totalPages}
          </Typography>
          <Button onClick={handleNextPage} disabled={currentPage === totalPages}>
            <ArrowForwardIcon />
          </Button>
        </Grid>
      )}

      <Dialog
        open={abrirDialog}
        aria-labelledby="customized-dialog-title"
        maxWidth={isMobile ? false : 'sm'}
        classes={{ paper: isMobile ? classes.dialogPaperMobile : '' }}
        style={{ marginTop: 35, marginBottom: 10 }}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            setAbrirDialog(false);
            resetarCampos();
          }
        }}
      >
        <DialogTitle>
          <Grid container alignItems="center">
            <Grid item xs={10} sm={11}>
              {editandoIndex !== null ? 'Editar Produto' : 'Adicionar Produto'}
            </Grid>
            <Grid item xs={2} sm={1}>
              <IconButton
                onClick={() => {
                  resetarCampos();
                  setAbrirDialog(false);
                }}
              >
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent className={classes.dialogContent} dividers>
          <div style={{ marginBottom: '16px' }}>
            <Autocomplete
              id="produto-select"
              options={opcoesAutocomplete}
              getOptionLabel={safeLabel}
              isOptionEqualToValue={isSameOption}
              value={produtoEstoqueSelecionado}
              noOptionsText={noShowMode ? 'Somente NO SHOW e TARIFA DE DESLOCAMENTO estão liberados.' : 'Nenhum item encontrado'}
              onChange={(event, newValue) => {
                if (noShowMode && newValue && !isNoShowAllowed(newValue)) {
                  abrirAlertAtencao(
                    'Item não permitido no NO SHOW',
                    'Quando NO SHOW estiver ativo, só pode adicionar NO SHOW e TARIFA DE DESLOCAMENTO.'
                  );
                  return;
                }
                setProdutoEstoqueSelecionado(newValue);
                setQuantidadeProduto(1);
                setErroDuplicidade(null);
              }}
              onInputChange={() => {
                setErroDuplicidade(null);
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label={
                    <span>
                      Selecionar Produto/Serviço <span style={{ color: 'red' }}> *</span>
                    </span>
                  }
                  variant="outlined"
                  error={Boolean(erroDuplicidade)}
                  helperText={erroDuplicidade || ''}
                />
              )}
              fullWidth
            />
          </div>

          <div style={{ marginBottom: '16px' }}>
            <TextField
              variant="outlined"
              fullWidth
              label={
                <>
                  Quantidade
                  <span style={{ color: 'red' }}> *</span>
                </>
              }
              type="number"
              value={quantidadeProduto}
              onChange={(event) => setQuantidadeProduto(event.target.value)}
              InputProps={{
                inputProps: {
                  min: 1,
                  max: produtoEstoqueSelecionado?.ehServico === false && usuarioEstoqueAtivo === true
                    ? produtoEstoqueSelecionado?.qtdDisponivel
                    : produtoEstoqueSelecionado?.quantidadeDisponivelRegras == true
                      ? produtoEstoqueSelecionado?.limiteQuantidade
                      : 100000,
                },
                endAdornment: (
                  <span style={{ marginLeft: 5 }}>
                    {produtoEstoqueSelecionado?.ehServico === false && usuarioEstoqueAtivo === true
                      ? `/${produtoEstoqueSelecionado?.qtdDisponivel ?? ''}`
                      : produtoEstoqueSelecionado?.quantidadeDisponivelRegras == true
                        ? `/${produtoEstoqueSelecionado?.limiteQuantidade ?? ''}`
                        : ''}
                  </span>
                ),
              }}
              InputLabelProps={{ shrink: true }}
            />
          </div>

          {produtoEstoqueSelecionado?.ehServico === false && (
            <>
              <FormControlLabel
                control={
                  <Checkbox
                    disabled={produtoEstoqueSelecionado?.ehServico === true}
                    checked={editandoIndex !== null ? produtoEstoqueSelecionado?.itemDeEstoque : itemEstoque}
                    onChange={(event) => {
                      const isChecked = event.target.checked;
                      if (editandoIndex !== null) {
                        setProdutoEstoqueSelecionado((prevProduto) => ({
                          ...prevProduto,
                          itemDeEstoque: isChecked,
                        }));
                      } else {
                        setItemEstoque(isChecked);
                      }
                    }}
                    color="primary"
                  />
                }
                label="Item do meu estoque"
              />

              <div style={{ marginBottom: '16px' }}>
                <FormControlLabel
                  control={
                    <Checkbox
                      disabled={produtoEstoqueSelecionado?.ehServico === true || produtoEstoqueSelecionado?.logisticaReversa === false || editandoIndex !== null}
                      checked={editandoIndex !== null ? produtoEstoqueSelecionado?.baseDeTroca : baseDeTroca}
                      onChange={(event) => {
                        const isChecked = event.target.checked;
                        if (editandoIndex !== null) {
                          setProdutoEstoqueSelecionado((prevProduto) => ({
                            ...prevProduto,
                            baseDeTroca: isChecked,
                          }));
                        } else {
                          setBaseDeTroca(isChecked);
                        }
                      }}
                      color="primary"
                    />
                  }
                  label="Base de troca"
                />
              </div>
            </>
          )}

          {(
            (produtoEstoqueSelecionado?.ehServico === false && (produtoEstoqueSelecionado?.logisticaReversa === true || produtoEstoqueSelecionado?.logisticaReversa == null) && produtoEstoqueSelecionado?.baseDeTroca === true) ||
            (produtoEstoqueSelecionado?.ehServico === false && (produtoEstoqueSelecionado?.logisticaReversa === true || produtoEstoqueSelecionado?.logisticaReversa == null) && baseDeTroca === true)
          ) && (
            <div style={{ marginBottom: '16px' }}>
              <Typography component="div" variant="body2">
                Informar abaixo o modelo do equipamento retirado do veículo do cliente e o motivo.
              </Typography>

              <div style={{
                display: 'flex',
                gap: '16px',
                marginTop: '16px',
                flexDirection: 'column'
              }}>
                <Autocomplete
                  id="produto-select-remanuf"
                  options={produtosRemanufatura}
                  getOptionLabel={(option) => `${option?.produtoNome ?? ''}`}
                  value={editandoIndex !== null
                    ? produtosRemanufatura?.find((option) => option.produtoCodigo === produtoEstoqueSelecionado?.codItemBaseDeTroca)
                    : (produtoEstoqueSelecionado?.nome?.includes('TERMINAL')
                      ? produtosRemanufatura?.find((option) => option.produtoNome === 'TERMINAL')
                      : produtoEstoqueSelecionado?.nome?.includes('MODULO')
                        ? produtosRemanufatura?.find((option) => option.produtoNome === 'MODULO')
                        : produtoEstoqueSelecionado?.nome?.includes('ANTENA')
                          ? produtosRemanufatura?.find((option) => option.produtoNome === 'ANTENA')
                          : produtoRemanufaturaSelecionado)
                  }
                  disabled={produtoEstoqueSelecionado?.ehServico === true || produtoEstoqueSelecionado?.logisticaReversa === false || editandoIndex !== null}
                  onChange={(event, newValue) => {
                    if (editandoIndex !== null) {
                      setProdutoEstoqueSelecionado((prevProduto) => ({
                        ...prevProduto,
                        codItemBaseDeTroca: newValue?.produtoCodigo || null,
                        nomeItemBaseDeTroca: newValue?.produtoNome || null,
                      }));
                    } else {
                      setProdutoRemanufaturaSelecionado(newValue);
                      setErroProdutoRemanufatura(false);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          Selecionar Produto <span style={{ color: 'red' }}> *</span>
                        </span>
                      }
                      variant="outlined"
                      error={erroProdutoRemanufatura}
                      helperText={erroProdutoRemanufatura ? 'Seleção obrigatória.' : ''}
                    />
                  )}
                />

                <Autocomplete
                  id="motivo-select"
                  options={motivosDesconto}
                  getOptionLabel={(option) => option?.label ?? ''}
                  value={motivosDesconto.find((item) => item.id === motivoProdutoRemanufatura) || null}
                  disabled={produtoEstoqueSelecionado?.ehServico === true || produtoEstoqueSelecionado?.logisticaReversa === false || editandoIndex !== null}
                  onChange={(event, newValue) => {
                    setMotivoProdutoRemanufatura(newValue ? newValue.id : null);
                    setErroMotivo(false);
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label={
                        <span>
                          Selecionar Motivo <span style={{ color: 'red' }}> *</span>
                        </span>
                      }
                      variant="outlined"
                      error={erroMotivo}
                      helperText={erroMotivo ? 'Seleção obrigatória.' : ''}
                    />
                  )}
                />
              </div>
            </div>
          )}
        </DialogContent>

        <DialogActions style={{ justifyContent: 'space-around' }}>
          <Button
            onClick={() => {
              resetarCampos();
              setAbrirDialog(false);
            }}
            variant="contained"
            size="large"
            style={{ marginBottom: '10px', marginTop: '10px', width: '40%', height: 55 }}
          >
            <span style={{ fontSize: '0.7rem' }}>Voltar</span>
          </Button>

          <BlueButton
            onClick={() => os?.status === 'Concluido' ? setAbrirDialogConfirmacao(true) : handleSalvarAlteracoes()}
            variant="contained"
            color="primary"
            size="large"
            style={{ marginBottom: '10px', marginTop: '10px', width: '40%', height: 55 }}
            disabled={!produtoEstoqueSelecionado || quantidadeProduto < 1 || carregandoEnvioProdutos || Boolean(erroDuplicidade)}
            startIcon={carregandoEnvioProdutos ? <CircularProgress size={20} /> : ''}
          >
            <span style={{ fontSize: '0.7rem' }}>
              {carregandoEnvioProdutos
                ? ' Salvando...'
                : (editandoIndex !== null ? 'Salvar Alterações' : 'Adicionar')}
            </span>
          </BlueButton>
        </DialogActions>
      </Dialog>

      <Dialog
        aria-labelledby="customized-dialog-title"
        open={abrirDialogConfirmacao}
        style={{ marginTop: 35, marginBottom: 10 }}
        onClose={(event, reason) => {
          if (reason !== 'backdropClick') {
            fecharModalConfirmacao();
          }
        }}
      >
        <DialogTitle>
          <Grid container alignItems="center">
            <Grid item xs={10} sm={11}>
              Confirmação
            </Grid>
            <Grid item xs={2} sm={1}>
              <IconButton onClick={fecharModalConfirmacao}>
                <CloseIcon />
              </IconButton>
            </Grid>
          </Grid>
        </DialogTitle>

        <DialogContent dividers>
          <Typography variant="subtitle1" gutterBottom style={{ textAlign: 'start' }}>
            <strong>OBS:</strong> A ordem de serviço já se encontra fechada. Ao inserir um novo item, ela retornará ao status de aguardando aprovação do cliente. Deseja continuar?
          </Typography>
        </DialogContent>

        <DialogActions style={{ justifyContent: 'space-around' }}>
          <Button
            variant="contained"
            fullWidth
            onClick={fecharModalConfirmacao}
            style={{ marginBottom: '10px', marginTop: '10px', width: '40%', height: 55 }}
          >
            <span style={{ fontSize: '0.7rem' }}>Não</span>
          </Button>

          <BlueButton
            variant="contained"
            color="primary"
            size="large"
            onClick={() => {
              fecharModalConfirmacao();
              handleSalvarAlteracoes();
            }}
            style={{ marginBottom: '10px', marginTop: '10px', width: '40%', height: 55 }}
          >
            <span style={{ fontSize: '0.7rem' }}>Sim</span>
          </BlueButton>
        </DialogActions>
      </Dialog>
    </>
  );
}
